/**
 * loaderTracker.js — tiny event emitter that counts in-flight API requests.
 *
 * The axios request/response interceptors call `inc()` / `dec()` and the
 * <GlobalLoader/> component subscribes to be notified when the loading
 * state flips on/off.
 */

let pending = 0;
const listeners = new Set();

function emit() {
    listeners.forEach((l) => {
        try { l(pending > 0, pending); } catch (_) { /* ignore */ }
    });
}

export function inc() {
    pending += 1;
    emit();
}

export function dec() {
    pending = Math.max(0, pending - 1);
    emit();
}

export function subscribe(listener) {
    listeners.add(listener);
    listener(pending > 0, pending);
    return () => listeners.delete(listener);
}

export function getPending() {
    return pending;
}
